<template>
  <v-dialog persistent v-model="show" width="500">
    <v-card>
      <v-card-title>
        <span class="headline">納入情報一括変更</span>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="!valid" @click="submit">{{
          $t('app.buttons.add')
        }}</v-btn>
        <v-btn @click="show = false">{{ $t('app.buttons.back') }}</v-btn>
      </v-card-actions>
      <v-form ref="form" v-model="valid">
        <v-card-text>
          <v-container fluid>
            <v-layout row wrap>
              <!-- <v-flex xs12>
            <remote-autocomplete
              label="納入場所"
              url="warehouses/acceptance-kv"
              v-model="finallyWarehouseId"
            ></remote-autocomplete>
              </v-flex>-->
              <v-flex xs12>
                <date-picker
                  :rules="[(v) => !!v || `納入予定日 can not be null`]"
                  label="納入予定日"
                  v-model="forecastDeliveryDate"
                  :min="new Date().format('yyyy-MM-dd')"
                ></date-picker>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  :rules="[
                    (v) =>
                      /^(((0|1)\d)|(2[0-3]))[0-5][0-9]$/.test(v) ||
                      `4桁の数の有効時間を入力してください`,
                  ]"
                  label="受入予定時間"
                  v-model="forecastDeliveryTime"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ['supplier'],
  data: () => ({
    show: false,
    finallyWarehouseId: null,
    forecastDeliveryDate: null,
    forecastDeliveryTime: null,
    valid: false,
  }),
  methods: {
    submit() {
      this.$emit('submit', {
        finallyWarehouseId: this.finallyWarehouseId,
        forecastDeliveryDate: this.forecastDeliveryDate,
        forecastDeliveryTime:
          this.$insert(this.forecastDeliveryTime, 0, 2, ':') + ':00',
      })
      this.show = false
    },
    popup() {
      this.show = true
    },
  },
}
</script>